module.exports = __webpack_public_path__ + "img/tertiary_6x4_z16.8d94b30f.svg";